<template>
  <div class="mw-split-container">
     <mw-dialog  size="mini_mini" :footerButton="btns" ref="dialog" :close-on-click-modal="false" :title="$lang('选择群组分类')">
        <div style="margin-top:20px">
          <el-radio-group v-model="check" >
            <el-radio
              v-for="i in list"
              :label="i.name"
              :key="i.id"
              style="display: block;margin-left: 50px;height: 30px;line-height:30px;font-size: 16px;font-weight: normal">{{i.name}}</el-radio>
          </el-radio-group>
        </div>
    </mw-dialog>

    <mw-dialog ref="titleDialog" :title=" form.id ? $lang('编辑群组') : $lang('新建群组') " :close-on-click-modal="false">

      <div class="mw-toolbar" v-if="toolbarPosition!='BOTTOM'">
        <el-button type="primary" @click="closeTitleDialog">
           <i class="fa fa-mail-reply "></i> {{$lang('关闭')}}</el-button>
        <el-button  type="primary" @click="saveTitle"> <i class="fa fa-file-text-o"></i>
          {{$lang('保存')}}</el-button>
      </div>

       <div class="mw-toolbar__body inner-toolbar__body">

          <mw-dialog size="mini_small" ref="unitDialog" :title="$lang('选择群组分类')" :footerButton="unitFooterButton" :close-on-click-modal="false">
            <mw-tree :url="unitTreeUrl" :defaultParams="defaultParams"  :async="true" ref="unitTree" :expandedFirst="true" :selectFirst="true" ></mw-tree>
          </mw-dialog>
          <template>
            <el-row>
              <el-form label-width="120px"  ref="ruleForm" :model="form" :rules="formRules">
                <el-col :span="24" >
                  <el-form-item :label="$lang('所属单位')" prop="unitName">
                    <el-input v-model="form.unitName" style="width: 80%" readonly></el-input>
                    <el-button type="primary" @click="showUnitDialog">选择</el-button>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('所属单位')"  v-show="false">
                    <el-input v-model="form.unitId" style="width: 80%" ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('群组分类')" prop="code">
                    <el-input v-model="form.code"  style="width:80%"></el-input>
                    <el-button  type="primary" @click="mwRef('dialog').show()">选择</el-button>
                  </el-form-item>

                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('群组名称')" prop="name">
                    <el-input v-model="form.name" style="width:80%"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('群组序列')">
                    <el-input-number v-model="form.sn" :controls="false"  :min="1" style="width:80%"></el-input-number>
                  </el-form-item>
                </el-col>

                <el-col :span="24" v-show="false">
                  <el-form-item>
                    <el-input
                      type="textarea"
                      :placeholder="$lang('请输入内容')"
                      v-model="form.departmentids">
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('群组成员')">
                  <div style="margin-bottom:5px;">
                    <el-input
                      type="textarea"
                      :placeholder="$lang('请输入内容')"
                      v-model="form.departments" readonly>
                    </el-input>
                    <el-button type="primary" @click="usersLoad" >选择</el-button>
                    <loadUsers ref="loadUsers" @closeDialog="getDeptUser"  :checkNodes="checkNodes" :showBDW="showBDW" :showQJT="showQJT" :unitId="form.unitId"></loadUsers>
                  </div>
                    <el-input
                      type="textarea"
                      :placeholder="$lang('请输入内容')"
                      v-model="form.users" readonly>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col v-show="false">
                  <el-form-item>
                    <el-input
                      type="textarea"
                      :placeholder="$lang('请输入内容')"
                      v-model="form.userids">
                    </el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="showGroupOutOrg" :span="24">
                  <el-form-item :label="$lang('外部单位')">
                    <el-input
                      type="textarea"
                      :placeholder="$lang('请输入内容')"
                      v-model="form.externalUnit">
                    </el-input>
                    <el-button @click="showOuterDept" type="primary">{{$lang("选择")}}</el-button>
                    </el-form-item>
                </el-col>
              </el-form>
            </el-row>
        </template>
        </div>

      <div class="mw-toolbar" v-if="toolbarPosition=='BOTTOM'" style="text-align: right;">
        <el-button  type="primary" @click="saveTitle"> <i class="fa fa-file-text-o"></i>
          {{$lang('保存')}}</el-button>
        <el-button type="primary" @click="closeTitleDialog">
          <i class="fa fa-mail-reply "></i> {{$lang('关闭')}}</el-button>
      </div>

      </mw-dialog>

      <mw-dialog :title="$lang('外部单位')" ref="externalDept" :footerButton="externalBtn" :close-on-click-modal="false">

        <div class="mw-toolbar__body">
          <p style="margin-top: 5px">{{$lang("外部单位(多个以回车换行)")}}</p>
          <el-input v-model="outerDept" type="textarea" :autosize="{ minRows: 10, maxRows: 20}" width="80%"></el-input>
        </div>

      </mw-dialog>
    <mw-dialog ref="impDialog" :title="$lang('导入群组数据')" @opened="showUpload" size="mini_small" :footerButton="impBtton">
      <div class="mw-dialog_body" style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item :label="$lang('导入说明')">
              <template>
                第一步：单击此处<el-button @click="downloadExcel" >下载模版</el-button><br/>
                第二步：按照模板格式录入数据;<br/>
                第三步：上传模板文件:
              </template>
            </el-form-item>
            <el-form-item label="上传文件:">
              <el-button ref="uploader">上传文件</el-button>
              <div class="el-upload__tip">只能上传.xls文件</div>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>
    <split-pane :defaultSize="358" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">
          <mw-dialog size="mini_small" ref="unitDialog1" title="选择群组分类" :footerButton="unitFooterButton1" :close-on-click-modal="false">
            <mw-tree :url="unitTreeUrl" :defaultParams="defaultParams" :async="false" :threeState="true" ref="unitTree1" :expandedFirst="true" :selectFirst="true" :multiple="true"></mw-tree>
          </mw-dialog>
           <div class="mw-toolbar">
              <el-button v-show="expandFlag==1" @click="expand" size="mini"><i class="fa fa-angle-double-down"></i>{{$lang('展开')}}</el-button>
              <el-button v-show="expandFlag!=1" @click="closed" size="mini"><i class="fa fa-angle-double-up"></i>{{$lang('折叠')}}</el-button>
              <el-button @click="changeOrg(1)" v-show="showCurOrg" size="mini"><i class="fa fa-user-circle-o"></i>{{$lang('本单位')}}</el-button>
              <el-button @click="changeOrg(2)" v-show="showAllOrg" size="mini"><i class="fa fa-users"></i>{{$lang('全集团')}}</el-button>
             <el-dropdown trigger="hover" @command="handleMoreCommand" v-show="userInfo.unitAdmin ||!isLimit">
               <el-button class="el-dropdown-link">
                 {{$lang('更多')}}<i class="el-icon-caret-bottom el-icon--right"></i>
               </el-button>
               <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                 <el-dropdown-item command="import" >{{$lang('导入')}}</el-dropdown-item>
                 <el-dropdown-item command="export">{{$lang('导出')}}</el-dropdown-item>
               </el-dropdown-menu>
             </el-dropdown>
           </div>
          <div>
            <mw-tree :url="groupTreeUrl" :autoLoad="false" :async="true"  :multipleLeaf="true"
              :dragEnable="true" :defaultParams="defaultTreeParams"  :expandedFirst="true" ref="groupTree" @changed="changed"  :selectFirst="true" ></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">

           <toolbar-table :layout="layout"  ref="aa" :pagination="false">
             <span slot="dropDown" v-show="userInfo.unitAdmin ||!isLimit">
               <el-dropdown trigger="hover" @command="handleSortCommand" v-show="userInfo.unitAdmin ||!isLimit">
                 <el-button class="el-dropdown-link">
                   {{$lang('排序')}}<i class="el-icon-caret-bottom el-icon--right"></i>
                 </el-button>
                 <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                   <el-dropdown-item command="sort" >{{$lang('排序')}}</el-dropdown-item>
                   <el-dropdown-item command="top">{{$lang('置顶')}}</el-dropdown-item>
                   <el-dropdown-item command="bottom">{{$lang('置底')}}</el-dropdown-item>
                   <el-dropdown-item command="up">{{$lang('上移')}}</el-dropdown-item>
                   <el-dropdown-item command="down">{{$lang('下移')}} </el-dropdown-item>
                 </el-dropdown-menu>
               </el-dropdown>
             </span>

           </toolbar-table>


        </div>
      </template>
    </split-pane>

  </div>
</template>
<script>
  import loadUsers from './user/loadUsers'
  import { mapGetters } from 'vuex';
  export default {
    components: {
      loadUsers
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'expUser'
      ])
    },
    data() {
      let me = this;

      var qzflList = (window.$Env && $Env.orgGroupCategoryList) ? $Env.orgGroupCategoryList :  [
        {'id': 1,'name': '机关领导'},{'id': 2,'name': '领导群组'}
      ]
      return {
        isLimit : false,
        layout: [],
        selUnitId:"",
        expandFlag:1,
        toolbarPosition:(window.$Env && $Env.toolbarPosition) || 'TOP',
        showGroupOutOrg:true,
        selUnitName:"",
        formSelUnitId:'',
        selCode:"",
        showQJT:true,
        showBDW:false,
        groupTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
        defaultTreeParams:{type:'address_book'},
        unitFooterButton: [
        {label: '取消', func: me.selectUnitCancel,type: "default"},
        {label: '确定', func: me.selectUnitSure}
        ],
        unitFooterButton1: [
          {label: '取消', func: me.selectUnitCancel1,type: "default"},
          {label: '确定', func: me.selectUnitSure}
        ],
        externalBtn:[
          {label: '确定', func: me.externalSure}
        ],
        btns: [{
          label: '取消',
          type: 'default',
          func:me.closeGroupDialog
        },{
          label: '确定',
          func: this.groupSure
        }],
        check: '',
        list: qzflList,
        unitTreeUrl: this.mwUrl('/api/org/getGroupUnitTree'),
        defaultParams:{deep:true,isContainSelf:false,parentId:""},
        selectUnitId: '',
        showAllOrg:false,
        showCurOrg:false,
        isExportGroup:false,
        form:{
          id:'',
          code: '',
          name: '',
          sn: 1,
          unitName: '',
          unitId:'',
          departments: '',
          departmentids:'',
          users: '',
          userids:'',
          externalUnit:''
        },

        formRules:{
          unitName:[
            {required: true, message:$lang("请选择所属单位"), trigger: 'change'}
          ],
          code:[
            {required: true, message:$lang("请选择分类"), trigger: 'change'}
          ],
          name:[
            {required: true, message:$lang("请输入名称"), trigger: 'blur'}
          ]
        },
        checkNodes: {dept: [],deptUsers :[]},
        outerDept:'',
        curSelParams:{},
        importAction:'/api/org/importGroupFromExcel',
        impBtton:[ {
          label: "取消",
          func:this.impCancel,
          type: "default"
        }],
        headers: {},
        curUnitId:"",
        isFirstOpen:true
      }
    },
    mounted() {
       let me = this;
       if(window.$Env && $Env.hideGroupOutOrg){
         me.showGroupOutOrg = false;
       }
       me.layout = [
         [{
         span:0,
         type: 'menu',
         label: '群组管理',
         api: 'org.listGroupDataByType',
         defaultParams:{
           type:'address_book'
         },
         columns: [
          {type: 'selection'},{prop:'sn',width:'55',label:'序号'},
          {prop: 'name',label: '名称',slot:{type:"href",func:me.openForm}},
          {prop: 'departments', label: '部门成员',tooltip:true},
          {prop: 'users', label: '用户成员',tooltip:true},
          {prop: 'createUser', label: '修改者'}
        ]
       },{
         span: 12,
         type: 'button',
         items: [{
           label: '添加',
           func: me.addTitle
         },{
           label: '删除',
           func: me.deleteGroup,
           icon:"el-icon-delete"
         }],suffixSlot:"dropDown"
       },{
         span: 6,
         type: 'searchText',
         name:'name',
         offset: 4,
         func: me.search
       }]
       ]
       var isSysAdmin = this.isSysAdmin();
       if(this.userInfo.developer || isSysAdmin){
          this.showCurOrg = true;
          this.defaultParams.parentId = this.userInfo.owner||"";
        }else{
          if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
            this.defaultTreeParams.unitId = this.$store.getters.curUnit[0].id;
            this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
          }
        }
        this.mwRef('groupTree').renderTree();
       me.$nextTick(function(){

        $(me.$el).find(".el-row").append('<button id="help" style="float:right;margin-top:8px;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>帮助</span></span></button>');
        $("#help").click(function(){
          me.showHelp();
        })
      })

     },
    methods: {
       showUpload(){
         if(this.isFirstOpen){
           this.initUploader();
           this.isFirstOpen=false;
         }
       },
       initUploader(){
          let me=this;
          let cfg={
            buttonId:me.mwRef('uploader').$el,
            maxSize:500,
            action:me.importAction,
            accept:"xls"
          }
          let fn={
            fileUploaded(up, file,resp){
               me.importSuccessCallback(resp,file,up);
             }
          }
          PF.initPupload(cfg,fn);
      },
      changed(data){
        let me =this;
        if(!data.id){
          return;
        }
        let params = {type:'address_book'};
        let unitText = "";
        if(data.code){
          params.unitId = data.unitId;
          unitText = data.unitName;
          params.code = data.code;
          me.selCode = data.code;
        }else{
            params.unitId = data.id;
            unitText = data.text;
        }
        me.selUnitId = params.unitId;
        me.selUnitName = unitText;
        me.curSelParams = params;
        $.post("/api/org/listGroupDataByType",params,function(res){
          me.mwRef('aa').refreshTableDataList(res.result);
        })
      },
      showHelp(){
        PF.showHelp({url:'/helpDoc/platform/groupManager.md'});
      },
      refreshGridData(){
        let me = this;
        $.post("/api/org/listGroupDataByType",me.curSelParams,function(res){
          let records =  me.mwRef('aa').getMultipleSelection();
          me.mwRef('aa').refreshTableDataList(res.result,function(){
            if(records && records.length > 0 && res.result && res.result.length > 0){
              let row = records[0];
              _.each(res.result,function(v){if(v.id==row.id ) row = v;})
              me.mwRef('aa').clearSelection();
              me.mwRef('aa').toggleRowSelection(row,true);
            }
          });
        })
      },
      addTitle(){
        this.resetFields();
        this.form.unitId = this.selUnitId ;
        this.form.unitName = this.selUnitName;
        this.form.code = this.selCode;
        this.showDialog('titleDialog');

      },
      openForm:function(data){
        let fd = {};
        fd = _.assign(fd,data)
        this.form = fd;
        this.showDialog('titleDialog');
      },
      showUnitDialog() {
        let me = this;
        me.selectUnitId = me.form.unitId;
        me.isExportGroup=false;
        this.showDialog('unitDialog');
        // MW.test(function(){
        //   if(me.mwRef('unitTree'))
        //    return true;
        //    return false;
        // },function(){
        //   me.defaultParams.parentId=me.curUnitId;
        //   me.mwRef('unitTree').renderTree();
        // },50);
      },
      isSysAdmin(){
        if(this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") !=-1){
          return true;
        }
        return false;
      },
      //单位选择
      selectUnitSure() {
        let me=this;
        let tree;
        if(this.isExportGroup)
            tree=this.mwRef('unitTree1');
        else
            tree=this.mwRef('unitTree');
        let data = tree.getSelected();
        if (!data) {
          this.mwMsg('warning', '请选择单位');
        } else {
          if(this.isExportGroup){
            let ids=data.map((v)=>{return v.id});
            me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportGroupToExcel"),{unitId:ids.join(",")},false,"");
            this.closeDialog('unitDialog1');
          }else{
            me.form.unitId = data.id ;
            me.form.unitName = data.text;
            this.selectUnitCancel();
          }
        }
      },
      deleteGroup(data){
        let me = this;
        if(!data || data.length===0){
          this.mwMsg('warning', '请选择数据');
          return;
        }
        let ids = [];
        $.each(data,function(i,d){
          ids.push(d.id);
        })
        me.mwConfirm('您确定要删除此群组?').then(() => {
          PF.ajax("api/org/deleteAddressBookGroup",ids).then((res)=>{
              if (res.result > 0) {
                me.mwMsg("删除成功");
                me.refreshData();
              }
          });
        })
      },
      selectUnitCancel() {
        this.closeDialog('unitDialog');
      },
      selectUnitCancel1() {
        this.closeDialog('unitDialog1');
      },
      closeTitleDialog(){
        this.resetFields();
        this.closeDialog('titleDialog');
      },
      processSelData:function(loadUserObj){
        if(loadUserObj){
          if(loadUserObj.deptUsers){
            loadUserObj.deptUsers.splice(0, loadUserObj.deptUsers.length);
          }else{
            loadUserObj.deptUsers = [];
          }
          if(loadUserObj.dept){
            loadUserObj.dept.splice(0, loadUserObj.dept.length);
          }else{
            loadUserObj.dept = [];
          }
        }
         if(this.form.userids){
          let names =this.form.users.split(',');
          let ids= this.form.userids.split(',');
          for(let i = 0;i< names.length;i++){
            if(loadUserObj){
              loadUserObj.deptUsers.push({id : ids[i],name: names[i]});
            }else{
              this.checkNodes.deptUsers.push({id : ids[i],name: names[i]})
            }
          }
        }else{
          this.checkNodes.deptUsers = [];
        }
        if(this.form.departmentids){
          let names =this.form.departments.split(',');
          let ids= this.form.departmentids.split(',');
          for(let i = 0;i< names.length;i++){
            if(loadUserObj){
              loadUserObj.dept.push({id : ids[i],name: names[i]})
            }else{
              this.checkNodes.dept.push({id : ids[i],name: names[i]})
            }
          }
        }else{
          this.checkNodes.dept = [];
        }
      },
      usersLoad(){
        let me = this;
        if(!this.form.unitId){
            this.mwMsg('warning', '请选择单位');
          return;
        }
        let isShowed = this.formSelUnitId ;
        this.formSelUnitId = this.form.unitId;
        this.mwRef('loadUsers').show();
        if(isShowed){
          me.mwRef("loadUsers").mwRef("deptTreeData2").unCheckAll(true);
          setTimeout(function(){
            let loadUserObj =   me.mwRef('loadUsers');
            if(loadUserObj.users){
              loadUserObj.users.splice(0, loadUserObj.users.length);
            }
            me.processSelData(loadUserObj);
            loadUserObj.defaultParams.rootId = me.formSelUnitId;
            loadUserObj.mwRef("deptTreeData2").refresh();
          },50)
        }
        this.processSelData();
      },
      refreshData(noRefreshTree){
        //this.mwRef('aa').refreshTable()
        if(!noRefreshTree){
          // this.defaultTreeParams.t = Date.now();
          this.mwRef('groupTree').refresh();
        }
        this.refreshGridData();
      },
      showOuterDept(){
        this.showDialog('externalDept');
      },
      saveTitle(){
        var me=this;
        me.mwRef('ruleForm').validate((valid) => {
          if (valid) {
            $.post("/api/org/saveAddressBookGroup",this.form).then(function(data){
                me.mwRef('titleDialog').hide();
                me.refreshData();
                me.resetFields();
            });
          }
        });
      },
      handleSortCommand(command) {
        let me = this;
        let multipleSelection =  this.mwRef('aa').getMultipleSelection();
        me.doSortSN(command,multipleSelection);
      },
      processSelRowData(){
        let me = this;
        this.mwRef('aa').$on("dataLoaded",function(datas){
          let records =  me.mwRef('aa').getMultipleSelection();
          if(records && records.length > 0){
            let row = records[0];
            _.each(datas,function(v){if(v.id==row.id || v.userId==row.userId) row = v;})
            me.mwRef('aa').clearSelection();
            me.mwRef('aa').toggleRowSelection(row,true);
          }
        })
      },
      sort(){
          this.doSortSN("sort");
      },
      up(data){
        this.doSortSN("up",data);
      },
      down(data){
        this.doSortSN("down",data);
      },
      top(data){
        this.doSortSN("top",data);
      },
      bottom(data){
        this.doSortSN("bottom",data);
      },
      doSortSN(flag,data){
        let me = this;
        let params =me.curSelParams;
        params.flag = flag;
        if(flag != "sort"){
          if(!data || data.length != 1){
            this.mwMsg('warning', $lang('请选择一条数据'));
            return;
          }
          params.id = data[0].id;
        }
        PF.ajax("api/org/updateGroupSN",params).then((res)=>{
          if(res.result){
             me.refreshData(true);
          }
        });
      },
      showDialog(a){
        this.mwRef(a).show();
      },
      closeDialog(a){
        this.mwRef(a).hide();
      },
      closeGroupDialog(){
        this.closeDialog("dialog");
      },
      groupSure(data){
        this.form.code=this.check;
        this.closeGroupDialog();
      },

      getDeptUser(){
        let dept =  this.mwRef('loadUsers').getValue().dept;
        let users =  this.mwRef('loadUsers').getValue().users;
        let userids =[],user = [],departmentids=[],departments=[];
        users.forEach(item => {
          userids.push(item.id);
          user.push(item.name)
        });
        dept.forEach(item => {
          departmentids.push(item.id);
          departments.push(item.name)
        });
        this.form.userids =  userids.join();
        this.form.users = user.join();
        this.form.departmentids =  departmentids.join();
        this.form.departments = departments.join();
      },
      resetFields() {
        var me = this;
        me.form.id = "";
        me.form.unitName = "";
        me.form.unitId = "";
        me.form.code = "";
        me.form.name = "";
        me.form.sn = "";
        me.form.departmentids = "";
        me.form.departments = "";
        me.form.users = "";
        me.form.userids = "";
        me.form.externalUnit = "";
        /*var ruleFormObj = me.mwRef('ruleForm');
        if(ruleFormObj){
            ruleFormObj.resetFields();
        }*/
      },
      refresh() {
        this.resetFields();
        this.mwRef('groupTree').refresh();
      },
      expand() {
        this.expandFlag = 2;
        this.mwRef('groupTree').openAll();
      },
      closed() {
        this.expandFlag = 1;
        this.mwRef('groupTree').closeAll();
      },
      externalSure(){
         let outerDept = this.outerDept.split("\n");
         this.form.externalUnit = outerDept.join();
         /*if(this.form.departments){
           this.form.departments =this.form.departments+ ','+outerDept.join()}
         else{
           this.form.departments =outerDept.join()
         }*/
         this.mwRef('externalDept').hide();
      },
      changeOrg(type){
        if(type&&type=="1"){
          this.showAllOrg=true;
          this.showCurOrg=false;
          if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
            this.defaultTreeParams.unitId = this.$store.getters.curUnit[0].id;
            this.mwRef('groupTree').refresh();
          }
        }else{
          this.showAllOrg=false;
          this.showCurOrg=true;
          this.defaultTreeParams.unitId = "";
          this.mwRef('groupTree').refresh();
        }
      },
      handleMoreCommand(command){
        let me=this;
        if(command === 'import'){
          this.mwRef('impDialog').show();
        }
        if(command === 'export'){
          // let dataTable = me.mwRef('aa');
          // let multipleSelection = dataTable.getMultipleSelection();
          // if(multipleSelection && multipleSelection.length >0){
          //   let groupIds = [];
          //   multipleSelection.forEach((val) => {
          //     groupIds.push(val.id);
          //   });
          //   me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportGroupToExcel"),{},false,PF.encode({groupIds:groupIds}));
          // }else{
            this.isExportGroup=true;
            this.showDialog('unitDialog1');
            // MW.test(function(){
            //   if(me.mwRef('unitTree1'))
            //   return true;
            //   return false;
            // },function(){
            //   me.defaultParams.parentId=me.curUnitId;
            //   me.mwRef('unitTree1').renderTree();
            // },50);
          //}
        }
      },
      impCancel(){
        this.mwRef('impDialog').hide();
      },
      importSuccessCallback(response, file) {
        if(response.result){
          this.mwRef('groupTree').refresh();
          PF.show('message',{html:response.result.errMsg});
          this.mwRef('impDialog').hide();
        }
        this.mwRef("importData").clearFiles();
      },
      downloadExcel(){
        var me = this;
        me.mwUtil.downloadAttachment("/template_file/importGroupExcel.xls");
      }
    }
  }
</script>
<style scoped>
.toolbar-dialog {
      padding: 5px 10px;
      line-height: 35px ;
      margin-bottom: 5px;
      background-color: #f1f1f1;
   }

  .el-tree-node__content .el-checkbox {
    display: none;
  }

  .el-input, .el-textarea {
    width: 80%;
  }

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/groups.vue